module.exports = __webpack_public_path__ + "img/hyatt.fb0508ff.png";